import { render, staticRenderFns } from "./IntermediateThrowEventProps.vue?vue&type=template&id=45440012"
import script from "./IntermediateThrowEventProps.vue?vue&type=script&lang=js"
export * from "./IntermediateThrowEventProps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports